<div [formGroup]="form">
   @for (deviceEntry of form.controls | keyvalue: preserveControlOrder; track deviceEntry.key) {
   <ng-container [formGroupName]="deviceEntry.key">
      <mat-dialog-content>
         <mat-form-field class="flex-half">
            <mat-label>Select Phone</mat-label>
            <input
               formControlName="device"
               autocomplete="off"
               type="text"
               [lcsSingleSelect]="deviceSel"
               [singleItemAutoSelect]="false"
               [openPanelOnFocus]="true"
               [accountId]="accountId"
               ndtDeviceSelect
               [deviceTypesToExclude]="[DeviceTypes.RoveB2, DeviceTypes.RoveB4]"
               id="2e82fc01-ca6b-42f7-9b5c-9f9adea16527"
               [required]="true"
               [name]="'device'"
            />
            <ndt-device-select #deviceSel></ndt-device-select>
            @if (deviceEntry.value?.get('device')?.hasError('required')) {
            <mat-error> Phone is required. </mat-error>
            }
         </mat-form-field>
         <mat-form-field class="flex-half">
            <mat-label>Number of Line Keys</mat-label>
            <input
               matInput
               type="number"
               formControlName="numberOfLineKeys"
               id="b426cd30-d546-4ed4-aa63-9d309a113d5d"
               required
            />
            @if (deviceEntry.value?.get('numberOfLineKeys')?.hasError('required')) {
            <mat-error> Number of Line Keys is required. </mat-error>
            } @if ( deviceEntry.value?.get('numberOfLineKeys')?.hasError('min') ||
            deviceEntry.value?.get('numberOfLineKeys')?.hasError('max') ) {
            <mat-error>Number of Line Keys must be between 1 and 30. </mat-error>
            } @if (deviceEntry.value?.get('numberOfLineKeys')?.hasError('pattern')) {
            <mat-error>Number of Line Keys must be an integer.</mat-error>
            }
         </mat-form-field>
      </mat-dialog-content>
   </ng-container>
   }
</div>
